import React, { useEffect, useState } from "react";
import CustomNavbar from "./components/Navbar";
import Quem from "./components/Quem";
import Formacao from "./components/Formacao";
import Atendimento from "./components/Atendimento";
import Publicacoes from "./components/Publicacoes";
import Contato from "./components/Contato";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";

const sections = [
  {
    id: "inicio",
    title: "Manô Medeiros | Psicóloga CRP 07/33416",
    description:
      "Psicoterapia individual e de relação para pessoas LGBTI+ e mulheres, com atendimento online.",
    Component: Header,
  },
  {
    id: "quem-sou-eu",
    title: "Quem sou eu | Manô Medeiros",
    description:
      "Conheça a trajetória de Manô Medeiros, psicóloga com atuação junto a pessoas LGBTI+, mulheres e pessoas vivendo com HIV/AIDS.",
    Component: Quem,
  },
  {
    id: "formacao-e-atuacao",
    title: "Formação e Atuação | Manô Medeiros",
    description:
      "Formação acadêmica, especializações e atuação profissional de Manô Medeiros em psicoterapia sistêmica e diversidade.",
    Component: Formacao,
  },
  {
    id: "atendimento",
    title: "Atendimento psicológico online | Manô Medeiros",
    description:
      "Psicoterapia individual e de relação para pessoas adultas, com prática ética, crítica e atenta às interseccionalidades.",
    Component: Atendimento,
  },
  {
    id: "publicacoes",
    title: "Publicações | Manô Medeiros",
    description:
      "Publicações, entrevistas, participações e produções acadêmicas de Manô Medeiros.",
    Component: Publicacoes,
  },
  {
    id: "contato",
    title: "Contato | Manô Medeiros",
    description:
      "Entre em contato com Manô Medeiros por WhatsApp, e-mail ou Instagram para saber mais sobre atendimento psicológico.",
    Component: Contato,
  },
];

function updateMeta(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", content);
}

function updatePropertyMeta(property, content) {
  let meta = document.querySelector(`meta[property="${property}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", content);
}

function updateCanonical() {
  let canonical = document.querySelector('link[rel="canonical"]');

  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute("href", "https://manomedeiros.com.br/");
}

function App() {
  const [activeSection, setActiveSection] = useState("inicio");
  const [visibleSections, setVisibleSections] = useState({
    inicio: true,
    "quem-sou-eu": false,
    "formacao-e-atuacao": false,
    atendimento: false,
    publicacoes: false,
    contato: false,
  });
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const homeMeta = sections[0];

    document.title = homeMeta.title;
    updateMeta("description", homeMeta.description);
    updatePropertyMeta("og:title", homeMeta.title);
    updatePropertyMeta("og:description", homeMeta.description);
    updatePropertyMeta("og:url", "https://manomedeiros.com.br/");
    updateMeta("twitter:title", homeMeta.title);
    updateMeta("twitter:description", homeMeta.description);
    updateCanonical();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const navbarHeight =
        document.querySelector(".site-header")?.offsetHeight || 0;
      const isMobile = window.matchMedia("(max-width: 991.98px)").matches;

      setShowBackToTop(isMobile && window.scrollY > navbarHeight + 24);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.history.replaceState(null, "", "#inicio");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  /* useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const sectionId = entry.target.id;

          setVisibleSections((currentSections) => ({
            ...currentSections,
            [sectionId]: entry.isIntersecting,
          }));

          if (entry.isIntersecting) {
            setActiveSection(sectionId);
          }
        });
      },
      {
        rootMargin: '0px 0px -20% 0px',
        threshold: 0.08,
      },
    );

    sections.forEach(({ id }) => {
      const sectionElement = document.getElementById(id);

      if (sectionElement) {
        observer.observe(sectionElement);
      }
    });

    return () => observer.disconnect();
  }, []); */
  useEffect(() => {
    const handleScrollSpy = () => {
      const navbarHeight =
        document.querySelector(".site-header")?.offsetHeight || 0;
      const referencePoint = window.scrollY + navbarHeight + 120;

      let currentSection = "inicio";

      sections.forEach(({ id }) => {
        const sectionElement = document.getElementById(id);

        if (!sectionElement) {
          return;
        }

        if (referencePoint >= sectionElement.offsetTop) {
          currentSection = id;
        }
      });

      setActiveSection(currentSection);
    };

    handleScrollSpy();

    window.addEventListener("scroll", handleScrollSpy, { passive: true });
    window.addEventListener("resize", handleScrollSpy);

    return () => {
      window.removeEventListener("scroll", handleScrollSpy);
      window.removeEventListener("resize", handleScrollSpy);
    };
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const sectionId = entry.target.id;

          setVisibleSections((currentSections) => ({
            ...currentSections,
            [sectionId]: entry.isIntersecting,
          }));
        });
      },
      {
        rootMargin: "0px 0px -20% 0px",
        threshold: 0.08,
      },
    );

    sections.forEach(({ id }) => {
      const sectionElement = document.getElementById(id);

      if (sectionElement) {
        observer.observe(sectionElement);
      }
    });

    return () => observer.disconnect();
  }, []);

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);

    if (!sectionElement) {
      return;
    }

    const navbarHeight =
      document.querySelector(".site-header")?.offsetHeight || 0;
    const mobileScrollTarget =
      sectionId === "quem-sou-eu" ? sectionElement : null;
    const isMobile = window.matchMedia("(max-width: 991.98px)").matches;
    const desktopScrollTarget =
      sectionElement.querySelector("h1, h2") || sectionElement;
    const scrollTarget =
      isMobile && mobileScrollTarget ? mobileScrollTarget : desktopScrollTarget;
    const targetTop = scrollTarget.getBoundingClientRect().top + window.scrollY;
    let safeOffset = isMobile ? 24 : navbarHeight + 72;

    if (!isMobile && sectionId === "contato") {
      safeOffset += 120; // ajuste conforme necessário
    }
    const scrollTop = Math.max(targetTop - safeOffset, 0);

    window.history.replaceState(null, "", `#${sectionId}`);
    window.scrollTo({
      top: scrollTop,
      behavior: "smooth",
    });
  };

  return (
    <>
      <CustomNavbar
        activeSection={activeSection}
        onNavigate={scrollToSection}
      />
      <main className="main-content">
        {sections.map(({ id, Component }) => (
          <section
            id={id}
            className={`page-section ${visibleSections[id] ? "is-visible" : ""}`}
            key={id}
          >
            <Component />
          </section>
        ))}
      </main>
      <button
        type="button"
        className={`back-to-top-button ${showBackToTop ? "is-visible" : ""}`}
        aria-label="Voltar ao topo"
        onClick={scrollToTop}
      >
        &uarr;
      </button>
      <Footer />
    </>
  );
}

export default App;
